import { createStore, combineReducers, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import rootSaga from './sagas/rootSaga';
import weatherReducer from './reducers/weatherReducer';
// import citiesReducer from './reducers/cities';

const sagaMiddleware = createSagaMiddleware();

const reducer = combineReducers({
    WRstate: weatherReducer,
    // cities: citiesReducer
});

const d = (initialState = {}) => {
    const store = createStore(reducer, initialState, applyMiddleware(sagaMiddleware));
    sagaMiddleware.run(rootSaga);
    return store;
}
export default d;